import { Typography } from "@mui/material";

export function MenuHeader(props) {
  return <Typography variant="h5" color="primary" {...props} />;
}
